<template>
    <div :class="{'input-group':(currency)}">
        <span class="input-group-addon">
            <div v-if="currency">{{ currency }}</div>
        </span>
        <input class="form-control" :value="visibleValue" v-on:change="updateValue" />
        <input type="hidden" :name="name" :value="hiddenValue">
    </div>
</template>

<script>
import accounting from 'accounting'

export default {
    props: {
        currency: {
            default: ''
        },
        value: {
            required: true
        },
        name: {
            required: true
        },
        removecents: {
            default: true
        },
        onInput: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            hiddenValue: this.value,
            visibleValue: this.value
        }
    },

    mounted() {
        if (this.value) {
            let visibleValue = accounting.formatMoney(
              this.value, this.symbol()
            );
            let i = visibleValue.indexOf('.');
            let result;
            if (this.removecents) {
                result = visibleValue.slice(0, i)
            } else {
                result = visibleValue.slice(0, i + 3)
            }
            this.visibleValue = result
        } else {
            this.visibleValue = ''
        }
    },

    methods: {
        symbol() {
            if (this.currency === 'EUR') {
                return '€';
            }

            return null;
        },
        updateValue(e) {
            let result, value;

            if (e.target.value) {
                let visibleValue = accounting.formatMoney(
                  e.target.value, this.symbol()
                );
                value = accounting.unformat(e.target.value);

                let i = visibleValue.indexOf('.');

                if (this.removecents) {
                    result = visibleValue.slice(0, i)
                } else {
                    result = visibleValue.slice(0, i + 3)
                }
            } else {
                result = ''
                value = ''
            }

            this.visibleValue = result
            this.hiddenValue = value
            this.onInput(value);
        },

    }
}
</script>
